export default function isTablet() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false
  }

  const isTouch =
    window.matchMedia("(pointer: coarse)").matches ||
    window.matchMedia("(any-pointer: coarse)").matches ||
    window.matchMedia("(hover: none)").matches ||
    navigator.maxTouchPoints > 0

  const shortestSide = Math.min(window.innerWidth, window.innerHeight)

  return isTouch && shortestSide >= 600 && shortestSide < 1024
}
